



























































import Vue from 'vue';
import { DeviceModel, ReportModel } from '@/store/types';
import { rangedLatestStatus, dayStr, displayingTimeSpan } from '@/helper/deviceStatus';
import { Route } from 'vue-router';
import { DevicesRepository } from '@/repository/DevicesRepository';
import { ReportsRepository } from '@/repository/ReportsRepository';

export default Vue.extend({
  data() {
    return {
      deviceId: '',
      deviceFromAPI: {} as DeviceModel,
      reportsFromAPI: [] as ReportModel[],
      dataCondition: '',
      dataThreshold: '',
    };
  },
  created: function() {
    this.deviceId = this.$route.params.deviceId;
    this.fetch();
  },
  watch: {
    $route: function(newRoute: Route) {
      this.deviceId = newRoute.params.deviceId;
      this.fetch();
    },
  },
  computed: {
    device(): DeviceModel {
      const result = { ...this.deviceFromAPI };
      result.reports = this.reportsFromAPI;
      return result;
    },
  },
  methods: {
    fetch() {
      this.fetchDevice();
      this.fetchReports();
    },
    fetchDevice() {
      DevicesRepository.get(this.deviceId).then((res) => {
        this.deviceFromAPI = res.data;
        if (this.deviceFromAPI !== undefined) {
          if (this.deviceFromAPI.condition !== undefined) {
            this.dataCondition = this.deviceFromAPI.condition;
          }
          if (this.deviceFromAPI.threshold !== undefined) {
            this.dataThreshold = String(this.deviceFromAPI.threshold);
          }
        }
      });
    },
    fetchReports() {
      ReportsRepository.getByDeviceId(this.deviceId).then((res) => {
        this.reportsFromAPI = res.data;
      });
    },
    setDeviceCondition() {
      this.device.condition = this.dataCondition;
      DevicesRepository.put(this.device, ['condition']);
    },
    setDeviceThreshold() {
      this.device.threshold = Number(this.dataThreshold);
      DevicesRepository.put(this.device, ['threshold']);
    },
    rangedLatestLog(device: DeviceModel, time: Date): string {
      return rangedLatestStatus(device, time);
    },
    dayStr(date: Date): string {
      return dayStr(date);
    },
    displayingTimeSpan(date: Date): Date[] {
      return displayingTimeSpan(date);
    },
    deviceIsAlive(device: DeviceModel, time: Date) {
      return this.rangedLatestLog(device, time) === 'alive';
    },
    deviceIsDead(device: DeviceModel, time: Date) {
      return this.rangedLatestLog(device, time) === 'dead';
    },
  },
});
